import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { reset } from 'redux-form'
import { compose } from 'recompose'

import { notification, modal, logError } from 'redux/modules/app'
import { profileQuestions as profileQuestionsApi } from 'redux/modules/api'
import { schema, removeSchema, editSchema } from 'models/profile-questions'

function decorator(config = {}) {
  return ComposedComponent => {
    const enhance = compose(
      connect(
        ({ api, auth }) => ({
          profileQuestions: api.profileQuestions,
          activeOrganization: auth.organization
        }),
        { ...profileQuestionsApi, notification, modal, reset, logError }
      )
    )

    class ProfileQuestions extends Component {
      static propTypes = {
        params: PropTypes.object.isRequired,
        hocAwardId: PropTypes.number,
        activeOrganization: PropTypes.object.isRequired,
        getProfileQuestions: PropTypes.func.isRequired,
        getParticipantsAnswers: PropTypes.func.isRequired,
        notification: PropTypes.func.isRequired,
        modal: PropTypes.func.isRequired,
        logError: PropTypes.func.isRequired,
        reset: PropTypes.func.isRequired,
        editProfileQuestions: PropTypes.func.isRequired
      }

      static defaultProps = {
        params: {}
      }

      componentDidMount() {
        config.list && this.handleGetProfileQuestions()
        config.participantAnswers && this.props.hocAwardId &&
          this.handleGetParticipantAnswers(this.props.hocAwardId)
      }

      handleGetProfileQuestions = () => {
        this.props.getProfileQuestions(this.handleGetOrganizationId())
      }

      handleGetParticipantAnswers = awardId => {
        this.props.getParticipantsAnswers(awardId, {
          updateParams: 'PROFILE_QUESTION_OPTION,PROFILE_QUESTION'
        })
      }

      handleAddNewQuestion = (fields, oldQuestions) => {
        this.props
          .editProfileQuestions(
            this.handleGetOrganizationId(),
            schema(fields, oldQuestions)
          )
          .then(this.handleSuccess)
          .catch(this.handleError)
      }

      handleEditQuestion = (fields, oldQuestions) => {
        this.props
          .editProfileQuestions(
            this.handleGetOrganizationId(),
            editSchema(fields, oldQuestions)
          )
          .then(this.handleSuccessEdit)
          .catch(this.handleError)
      }

      handleRemoveQuestion = (id, oldQuestions) => {
        this.props
          .editProfileQuestions(
            this.handleGetOrganizationId(),
            removeSchema(id, oldQuestions)
          )
          .then(this.handleSuccessRemove)
          .catch(this.handleError)
      }

      handleGetOrganizationId = () => {
        const { params, activeOrganization } = this.props

        return params.id || activeOrganization.id
      }

      handleSuccess = () => {
        this.props.notification('New question has been added', {
          status: 'success',
          intlKey: 'notifications.new_question_has_been_added'
        })
        this.props.reset('form-add-new-question')
        this.handleEnd()
      }

      handleSuccessEdit = () => {
        this.props.notification('Question has been updated', {
          status: 'success',
          intlKey: 'notifications.question_has_been_updated'
        })
        this.handleEnd()
      }

      handleSuccessRemove = () => {
        this.props.notification('Question has been removed', {
          status: 'success',
          intlKey: 'notifications.question_has_been_removed'
        })
        this.handleEnd()
      }

      handleEnd = () => {
        this.handleGetProfileQuestions()
        this.props.modal(null)
      }

      handleError = err => {
        console.log('error', err.body && err.body.userMessage)
        this.props.logError(err)
      }
      render() {
        return (
          <ComposedComponent
            {...this.props}
            addNewQuestion={this.handleAddNewQuestion}
            removeQuestion={this.handleRemoveQuestion}
            editQuestion={this.handleEditQuestion}
            onGetParticipantsAnswers={this.handleGetParticipantAnswers}
          />
        )
      }
    }
    return enhance(ProfileQuestions)
  }
}

export default decorator
